import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout_template.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\",\"600\",\"700\",\"800\",\"900\"],\"display\":\"swap\",\"variable\":\"--font-inter\"}],\"variableName\":\"interFont\"}");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/opt/atlassian/pipelines/agent/build/node_modules/react-hot-toast/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/src/app/components/Navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/src/app/components/Sidebar.tsx");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider","useAuth"] */ "/opt/atlassian/pipelines/agent/build/src/contexts/Auth/Auth.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GlobalProvider"] */ "/opt/atlassian/pipelines/agent/build/src/contexts/Global/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SFCaseProvider"] */ "/opt/atlassian/pipelines/agent/build/src/contexts/SFCase.tsx");
